export const JOB_ALERT_CHANNEL = {
  EMAIL: "email",
  WHATSAPP: "whatsapp",
} as const;

export const JOB_ALERT_CHANNELS = [
  JOB_ALERT_CHANNEL.EMAIL,
  JOB_ALERT_CHANNEL.WHATSAPP,
] as const;
